import { render } from "./finishing.vue?vue&type=template&id=087c439c"
import script from "./finishing.vue?vue&type=script&lang=js"
export * from "./finishing.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__